import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators, AbstractControl } from "@angular/forms";
import { Router } from "@angular/router";
import { AuthService } from "./auth.service";
import { ToastrService } from "ngx-toastr";
import { HomeService } from "../home/home.services";

@Component({
  selector: "app-auth",
  templateUrl: "./auth.component.html",
  styleUrls: ["./auth.component.scss"],
})
export class AuthComponent implements OnInit {
  version = `Version :- V3`;
  loginForm!: FormGroup; // login form variable declaration to hold form values
  submitted = false;
  invalidCredentials = false;
  showForgotPasswordDialog: boolean = false;
  errorMsg: any;
  errorMessage: any;
  forgotPasswordForm!: FormGroup;
  emailsubmitted: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private authService: AuthService,
    private toastr: ToastrService,
    private HomeService: HomeService,
  ) { }

  ngOnInit(): void {
    localStorage.clear();
    this.loginForm = this.formBuilder.group(
      {
        email: ["", [Validators.required, Validators.email]], // email validations
        password: ["", [Validators.required, Validators.minLength(6)]], // password with 6 characters
      },
      {}
    );
    this.forgotPasswordForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.loginForm.controls;
  }

  get fpass(): { [key: string]: AbstractControl } {
    return this.forgotPasswordForm.controls;
  }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.loginForm.invalid) {
      return;
    }
    this.authService
      .postLoginDetails(
        this.loginForm.value.email,
        this.loginForm.value.password
      )
      .subscribe(
        (response) => {
          console.log("data--", response);
          if (response.success && response.success === true) {
            localStorage.setItem(
              "email",
              response.data.email || this.loginForm.value.email
            );
            localStorage.setItem(
              "page_access",
              JSON.stringify(response.data.page_access) || ""
            );
            localStorage.setItem(
              "sidebar_access",
              JSON.stringify(response.data.sidebar_access) || ""
            );
            localStorage.setItem(
              "lms_access",
              JSON.stringify(response.data.lms_access) || ""
            );
            localStorage.setItem(
              "lms_sections_access",
              JSON.stringify(response.data.lms_sections_access) || ""
            );
            localStorage.setItem(
              "lms_field_access",
              JSON.stringify(response.data.lms_field_access) || ""
            );
            // this.toastr.success(response.message);
            // this.invalidCredentials = false;
            // this.router.navigateByUrl("/home");

            // Parse the sidebar_access object to check access rights
            const sidebarAccess = response.data.sidebar_access
              ? JSON.parse(JSON.stringify(response.data.sidebar_access))
              : {};

            // Define your components with access keys and paths
            const components = [
              { title: "Data Directory", accessKey: "Data Directoryssss", path: "/datadirectory" },
              { title: "Search Molecule", accessKey: "Search Molecule", path: "/home" }, // Home page (priority)
              // { title: "Costing", accessKey: "Costing", path: "/costing" },
              { title: "Costing", accessKey: "Costing", path: "/new-costing" },
              { title: "Business Case", accessKey: "Business Case", path: "/settings" },
              { title: "Est API", accessKey: "Est API", path: "/est_api" },
              { title: "Est RLD", accessKey: "Est RLD", path: "/est_rld" },
              { title: "Commercial Intelligence", accessKey: "Commercial Intelligence", path: "/commercial_intelligence" },
              { title: "Upload Files", accessKey: "Upload Files", path: "/uploadfiles" },
              { title: "File Sales and Volume", accessKey: "File Sales and Volume", path: "/filessalesandvolume" },
              { title: "Scraping Update", accessKey: "Scraping Update", path: "/scrapingupdate" },
              { title: "LMS", accessKey: "LMS", path: "/logmanagement" },
              { title: "Error Dashboard", accessKey: "Error Dashboard", path: "/errordashboard" },
              { title: "Upload To Live", accessKey: "Upload To Live", path: "/uploadtolive" },
              { title: "User Registration", accessKey: "User Registration", path: "/user-registration" },
              { title: "Request Training", accessKey: "Request Training", path: "/request-training" },
              { title: "Product Dashboard", accessKey: "Product Dashboard", path: "/product-dashboard" },
              { title: "Excel Manager", accessKey: "Excel Manager", path: "/excel-manager" },
              { title: "Email Litigation", accessKey: "Email Litigation", path: "/litigation-dashboard" },
              { title: "Litigation Complaints", accessKey: "Litigation Complaints", path: "/litigation-complaints" },
              { title: "Important Updates", accessKey: "IMP Is In Live", path: "/important-updates" },
              { title: "Rights Wise Access", accessKey: "Rights Wise Access", path: "/register-user" }
            ];

            // Prioritize redirecting to home page if "Search Molecule" is true
            if (sidebarAccess["Search Molecule"] === true) {
              this.router.navigateByUrl("/home"); // Redirect to home
            } else {
              // Find the first accessible component and redirect
              const accessibleComponent = components.find(
                component => sidebarAccess[component.accessKey] === true
              );

              if (accessibleComponent) {
                this.router.navigateByUrl(accessibleComponent.path); // Redirect to the first accessible component
                this.toastr.success(response.message);
                this.invalidCredentials = false;
              } else {
                this.toastr.error("No access rights found!"); // Show error if no access is found
              }
            }
          } else {
            this.invalidCredentials = true;
            this.toastr.error(response.message);
          }
        },
        (err) => {
          console.log(err);
          this.invalidCredentials = true;
          this.toastr.error(
            typeof err === "string"
              ? err
              : err.message || "Login process errored."
          );
        }
      );
  }

  onReset() {
    this.submitted = false;
    this.loginForm.reset();
  }

  navigateToSignup() {
    this.router.navigateByUrl("/signup");
  }

  forgotPasswordDailog() {
    this.showForgotPasswordDialog = true;
  }

  onMailSubmit() {
    this.emailsubmitted = true;
    if (this.forgotPasswordForm.valid) {
      const email = this.forgotPasswordForm.value.email;
      let data = {
        email: this.forgotPasswordForm.value.email
      };
      console.log("email", email)
      this.HomeService.ForgotAdminPassword(data).subscribe((response) => {
        // console.log("response", response);
        this.toastr.success(response['message']);
        this.forgotPasswordForm.reset();
        this.showForgotPasswordDialog = false;
      },
        (error) => {
          this.toastr.error(error.error.error);
        });
    }
  }


  onMailCancel() {
    this.showForgotPasswordDialog = false;
    this.forgotPasswordForm.reset();
  }
}
